import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Logger, LoggerFactory } from '@rillion/core/logger';
import { SettingsSelectors } from '@rillion/store/settings';
import { SettingsActions } from '@rillion/store/settings/settings.actions';

@Injectable()
export class NetworkService {
  private logger: Logger;

  constructor(
    private store: Store,
    logService: LoggerFactory,
  ) {
    this.logger = logService.getLogger('NetworkService');

    this.registerBrowserHooks();
  }

  public isOffline(): Observable<boolean> {
    return this.store.select(SettingsSelectors.selectIsNetworkOffline);
  }

  private registerBrowserHooks() {
    window.addEventListener('offline', () => this.setOffline());
    window.addEventListener('online', () => this.setOnline());
    this.logger.debug('Registered browser hooks: [online/offline]');

    if (window.navigator.onLine) {
      this.setOnline();
    }
  }

  private setOnline() {
    this.logger.debug('Network is online');
    this.store.dispatch(SettingsActions.networkStatusFlag({ online: true }));
  }

  private setOffline() {
    this.logger.debug('Network is offline');
    this.store.dispatch(SettingsActions.networkStatusFlag({ online: false }));
  }
}
